// @flow
import * as React from 'react'
import styled from 'styled-components'
import {translate} from 'react-i18next'
import {
  Banner,
  Button,
  Career,
  FAQ,
  Loading,
  Section,
  Showcase,
  styles,
  Traits,
  Trait
} from 'tutellus-ui'
import {Query} from 'react-apollo'
import gql from 'graphql-tag'

import {Page} from './Page'
import {SubscriptionPricingTable} from './Subscription'

const FAQSection = styled(Section)`
    text-align: left;
`

export const CareerShowcase = translate('careers')(styled(({t, className}) =>
  <Query query={gql`{
        careers {
            code,
            name,
            background,
            image,
            courses { code },
            description
        }
    }`}>{ ({loading, error, data}/*: {loading: bool, data: any} */) =>
      <Loading while={loading}>{
        data && data.careers
          ? <Showcase className={className} size='8'
            more={t('view_all')} less={t('view_less')} sizes={{laptop: 2}}>{
              data.careers.map(({code, description, courses, ...career}) =>
                <Career key={code}
                  {...career}
                  courses={`${courses.length} ${t('courses')}`}>
                  { description }
                </Career>
              )
            }</Showcase>
          : null
      }</Loading>
    }</Query>
)``)
CareerShowcase.displayName = 'CareerShowcase'

const HowItWork = styled(Section)`
    & ${Traits} {
      @media ${styles.media.tablet} {
        grid-template-columns: repeat(2,1fr);
      }
      @media ${styles.media.laptop} {
        grid-template-columns: repeat(4,1fr);
      }
    }
`
HowItWork.displayName = 'HowItWork'

export const Careers = translate('careers')(({t}) =>
  <Page>
    <Banner background_url={t('background_url')}
      title={t('title')}>
      <p>{ t('description') }</p>
      <Button primary>{ t('view_careers') }</Button>
    </Banner>
    <HowItWork title={t('how_it_works_title')}>
      <p>{ t('how_it_works_description') }</p>
      <Traits>{
        JSON.parse(t('how_it_works')).map(how =>
          <Trait key={how}
            title={t(`hiw_${how}`)}
            icon={t(`hiw_${how}_icon`)}>
            { t(`hiw_${how}_explained`) }
          </Trait>
        )
      }</Traits>
    </HowItWork>
    <Section dark title={t('find_a_career')}>
      <CareerShowcase />
    </Section>
    <Section light title={t('select_a_plan_title')}>
      <p>{ t('select_a_plan_description') }</p>
      <SubscriptionPricingTable />
    </Section>
    <FAQSection title={t('faq')}>
      <FAQ list={JSON.parse(t('faqs'))} />
    </FAQSection>
  </Page>
)
Careers.displayName = 'Careers'



// WEBPACK FOOTER //
// ./src/pages/Careers.js